/** 2.5× the small auth button height (24px). Shared by sign-in, register, and Google entry buttons. */
export const authEntryButtonSx = {
  minHeight: "60px !important",
  height: 60,
  py: 0,
};
